import { Component, Input } from '@angular/core';
import { Icons } from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';
import { Color } from '@lsq-frontend/common-ui';
/**
 * Reusable styling for cluster of information
 * @export
 * @class PayLaterAmountClusterComponent
 * @property {string} tooltipText Body of the tooltip
 * @property {string} tooltipPlacement Optional override of the tooltip orientation
 * @property {string} label The label above the dollar amount
 * @property {boolean} divideLine Apply a line to the value
 * @property {boolean} greenCircleIcon Add green circle to the label
 * @property {boolean} grayCircleIcon Add gray circle to the label
 * @property {boolean} textAlign Text align for the text
 */
@Component({
    selector: 'pay-later-amount-cluster',
    templateUrl: './pay-later-amount-cluster.component.html',
    styleUrls: ['./pay-later-amount-cluster.component.scss']
})
export class PayLaterAmountClusterComponent {
    @Input() public tooltipText: string;
    @Input() public tooltipPlacement = PopoverPlacement.TopLeft;
    @Input() public label?: string;
    @Input() public divideLine = false;
    @Input() public greenCircleIcon = false;
    @Input() public grayCircleIcon = false;
    @Input() public textAlign: string = 'left';
    @Input() public topRowStyle: Record<string, any> = {};
    public readonly icons = Icons;
    public readonly colors = Color;

    constructor() {}
}
